import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useRoutingRulesData = (routingRuleId?: string) =>
    useRepositorySuspenseQuery('routingRules', 'newGetAll', {
        routingRuleIds: routingRuleId ? [routingRuleId] : undefined,
        extent: {
            routingRuleAssignments: true,
            rateAssignments: true,
            accountingCategoryAssignments: true,
            productCategoryAssignments: true,
            productAssignments: true,
            profiles: false,
        },
    });
